import React from 'react';

import RegistrationWrapper from 'common/canny/register/RegistrationWrapper';
import VStack from 'common/ui/VStack';

import AdminOnboardingFieldLabel from './AdminOnboardingFieldLabel';
import AdminOnboardingMultiSelect from './AdminOnboardingMultiSelect';
import { CollectFeedbackOptionValue, howOptions } from './data';

import type { UseCase } from './Types';

type Props = {
  onChange: (useCase: UseCase) => void;
  useCase: UseCase;
};

const AdminOnboardingHow = ({ onChange, useCase }: Props) => {
  const onChangeSelect = (motivations: string[]) => {
    const wantsPrivate =
      motivations.includes(CollectFeedbackOptionValue.Autopilot) ||
      motivations.includes(CollectFeedbackOptionValue.Behalf);
    onChange({
      ...useCase,
      motivations,
      private: wantsPrivate,
    });
  };

  const { motivations } = useCase;
  return (
    <RegistrationWrapper.Content className="gap-6">
      <RegistrationWrapper.Header>
        <RegistrationWrapper.Title>How do you want to collect feedback?</RegistrationWrapper.Title>
      </RegistrationWrapper.Header>
      <VStack className="gap-2">
        <AdminOnboardingFieldLabel isRequired>Select all that apply</AdminOnboardingFieldLabel>
        <AdminOnboardingMultiSelect
          optionType="card"
          onChange={onChangeSelect}
          options={howOptions}
          selected={motivations}
        />
      </VStack>
    </RegistrationWrapper.Content>
  );
};

export default AdminOnboardingHow;
